import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
// 组件存放的路径使用按需加载，webpack 打包时会分隔成单独的js文件，不会全部打包到 app.js 文件下面
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: resolve => require(['@/pages/LoginV2'], resolve)
    },
    {
      path: '/Main',
      name: 'Main',
      component: resolve => require(['@/pages/main'], resolve),
      children: [
        {
          name: 'Home',
          path: 'Home',
          components: { Home: () => import('@/pages/Home') }
        },
        {
          path: 'Driver',
          name: 'Driver',
          components: { Driver: () => import('@/pages/Driver') }
        },
        {
          path: 'ItemOther',
          name: 'ItemOther',
          components: { ItemOther: () => import('@/pages/ItemOther') }
        },
        {
          path: 'Role',
          name: 'Role',
          components: { Role: () => import('@/pages/Role') }
        },
        {
          path: 'Supplier',
          name: 'Supplier',
          components: { Supplier: () => import('@/pages/Supplier') }
        },
        {
          path: 'User',
          name: 'User',
          components: { User: () => import('@/pages/User') }
        },
        {
          path: 'Button',
          name: 'Button',
          components: { Button: () => import('@/pages/Button') }
        },
        {
          path: 'Menu',
          name: 'Menu',
          components: { Menu: () => import('@/pages/Menu') }
        },
        {
          path: 'SiloWatchTimeOption', //筒仓排班时间信息设置
          name: 'SiloWatchTimeOption',
          components: { SiloWatchTimeOption: () => import('@/pages/SiloWatchTimeOption') }
        },
        {
          path: 'SiloMonitorReport', //筒仓日报表
          name: 'SiloMonitorReport',
          components: { SiloMonitorReport: () => import('@/pages/SiloMonitorReport') }
        },
        {
          path: 'GlobalParameters',
          name: 'GlobalParameters',
          components: { GlobalParameters: () => import('@/pages/GlobalParameters') }
        },
        {
          path: 'PurchaseOrder',
          name: 'PurchaseOrder',
          components: { PurchaseOrder: () => import('@/pages/PurchaseOrder') }
        },
        {
          path: 'Vehicle',
          name: 'Vehicle',
          components: { Vehicle: () => import('@/pages/Vehicle') }
        },
        {
          path: 'PurchaseReport',
          name: 'PurchaseReport',
          components: { PurchaseReport: () => import('@/pages/PurchaseReport') }
        },
        {
          path: 'OperationKanBan',
          name: 'OperationKanBan',
          components: { OperationKanBan: () => import('@/pages/kanban/OperationKanBan1') }
        },
        {
          path: 'TankDataKanBan',
          name: 'TankDataKanBan',
          components: { TankDataKanBan: () => import('@/pages/kanban/TankDataKanBan') }
        },
        {
          path: 'StoveTowerKanBan', //烘干塔看板
          name: 'StoveTowerKanBan',
          components: { StoveTowerKanBan: () => import('@/pages/kanban/StoveTowerKanBan') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量看板路由-烘干预榨看板
          path: 'RapeseedYieldKanBan',
          name: 'RapeseedYieldKanBan',
          components: { RapeseedYieldKanBan: () => import('@/pages/kanban/RapeseedYieldKanBan') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量看板路由-毛油产量看板
          path: 'CrudeOilYieldKanBan',
          name: 'CrudeOilYieldKanBan',
          components: { CrudeOilYieldKanBan: () => import('@/pages/kanban/CrudeOilYieldKanBan') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量看板路由-成品油产量看板
          path: 'RefinedOilYieldKanBan',
          name: 'RefinedOilYieldKanBan',
          components: { RefinedOilYieldKanBan: () => import('@/pages/kanban/RefinedOilYieldKanBan') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量看板路由-发油看板
          path: 'OilDispatchKanBan',
          name: 'OilDispatchKanBan',
          components: { OilDispatchKanBan: () => import('@/pages/kanban/OilDispatchKanBan') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量看板路由-调配原料看板
          path: 'BlendingFeedstockKanBan',
          name: 'BlendingFeedstockKanBan',
          components: { BlendingFeedstockKanBan: () => import('@/pages/kanban/BlendingFeedstockKanBan') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量报表路由-烘干预榨报表
          path: 'RapeseedYieldReport',
          name: 'RapeseedYieldReport',
          components: { RapeseedYieldReport: () => import('@/pages/report/RapeseedYieldReport') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量报表路由-毛油产量报表
          path: 'CrudeOilYieldReport',
          name: 'CrudeOilYieldReport',
          components: { CrudeOilYieldReport: () => import('@/pages/report/CrudeOilYieldReport') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量报表路由-成品油产量报表
          path: 'RefinedOilYieldReport',
          name: 'RefinedOilYieldReport',
          components: { RefinedOilYieldReport: () => import('@/pages/report/RefinedOilYieldReport') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量报表路由-发油报表
          path: 'OilDispatchReport',
          name: 'OilDispatchReport',
          components: { OilDispatchReport: () => import('@/pages/report/OilDispatchReport') }
        },
        {
          //2026-07-31 由吴伟修改 添加流量报表路由-调配原料报表
          path: 'BlendingFeedstockReport',
          name: 'BlendingFeedstockReport',
          components: { BlendingFeedstockReport: () => import('@/pages/report/BlendingFeedstockReport') }
        },
        {
          path: 'SaleReport',
          name: 'SaleReport',
          components: { SaleReport: () => import('@/pages/SaleReport') }
        },
        {
          path: 'SaleOrder',
          name: 'SaleOrder',
          components: { SaleReport: () => import('@/pages/SaleOrder') }
        },
        {
          path: 'Equipment', // 设备台账
          name: 'Equipment',
          components: { Equipment: () => import('@/pages/equipment/Equipment') }
        },
        {
          path: 'EquipmentCharts', // 设备统计图表
          name: 'EquipmentCharts',
          components: { EquipmentCharts: () => import('@/pages/equipment/report/EquipmentCharts') }
        },
        {
          path: 'EquipmentMaintenanceCharts', // 设备维保统计图表
          name: 'EquipmentMaintenanceCharts',
          components: { EquipmentMaintenanceCharts: () => import('@/pages/equipment/report/EquipmentMaintenanceCharts') }
        },
        {
          path: 'EquipmentInfoClass', // 设备信息分类
          name: 'EquipmentInfoClass',
          components: { EquipmentInfoClass: () => import('@/pages/equipment/EquipmentInfoClass') }
        },
        {
          path: 'EquipmentClass', // 设备类型
          name: 'EquipmentClass',
          components: { EquipmentClass: () => import('@/pages/BasicData/EquipmentClass') }
        },
        {
          path: 'EquipmentLocationClass', // 设备位置
          name: 'EquipmentLocationClass',
          components: { EquipmentLocationClass: () => import('@/pages/BasicData/EquipmentLocationClass') }
        },
        {
          path: 'EquipmentLocationShift', // 设备位置值班排班表
          name: 'EquipmentLocationShift',
          components: { EquipmentLocationShift: () => import('@/pages/BasicData/EquipmentLocationShift') }
        },
        {
          path: 'SpareParts',
          name: 'SpareParts', // 备品备件台账
          components: { SpareParts: () => import('@/pages/equipment/SpareParts') }
        },
        {
          path: 'EquipMaintenanceCommonParam',
          name: 'EquipMaintenanceCommonParam', // 设备维修常用参数
          components: { EquipMaintenanceCommonParam: () => import('@/pages/equipment/EquipMaintenanceCommonParam') }
        },
        {
          path: 'EquipRepair',
          name: 'EquipRepair', // 设备报修
          components: { EquipRepair: () => import('@/pages/equipment/repair/EquipRepair') }
        },
        {
          path: 'EquipRepairBill',
          name: 'EquipRepairBill', // 设备维修单
          components: { EquipRepairBill: () => import('@/pages/equipment/repair/EquipRepairBill') }
        },
        {
          path: 'ComprehensiveRepair',
          name: 'ComprehensiveRepair', // 综合事务报修
          components: { ComprehensiveRepair: () => import('@/pages/equipment/repair/ComprehensiveRepair') }
        },
        {
          path: 'ComprehensiveRepairBill',
          name: 'ComprehensiveRepairBill', // 综合事务工单
          components: { ComprehensiveRepairBill: () => import('@/pages/equipment/repair/ComprehensiveRepairBill') }
        },
        {
          path: 'EquipRepairPlan',
          name: 'EquipRepairPlan', // 设备维修计划
          components: { EquipRepairPlan: () => import('@/pages/equipment/repair/EquipRepairPlan') }
        },
        {
          path: 'RepairList',
          name: 'RepairList', // 设备维修记录
          components: { RepairList: () => import('@/pages/equipment/repair/RepairList') }
        },
        {
          path: 'ComprehensiveRepairList',
          name: 'ComprehensiveRepairList', // 综合事务维修记录
          components: { ComprehensiveRepairList: () => import('@/pages/equipment/repair/ComprehensiveRepairList') }
        },
        {
          path: 'EquipMaintenanceStandard',
          name: 'EquipMaintenanceStandard', //设备保养标准
          components: { EquipMaintenanceStandard: () => import('@/pages/equipment/maintenance/EquipMaintenanceStandard') }
        },
        {
          path: 'BYPlanItems',
          name: 'BYPlanItems', //设备保养计划项明细
          components: { BYPlanItems: () => import('@/pages/equipment/maintenance/BYPlanItems') }
        },
        {
          path: 'EquipBYPlan',
          name: 'EquipBYPlan', //设备保养计划
          components: { EquipBYPlan: () => import('@/pages/equipment/maintenance/EquipBYPlan') }
        },
        {
          path: 'BYBill',
          name: 'BYBill', //设备保养工单
          components: { BYBill: () => import('@/pages/equipment/maintenance/BYBill') }
        },
        {
          path: 'MyBYBill',
          name: 'MyBYBill', //我的设备保养工单
          components: { MyBYBill: () => import('@/pages/equipment/maintenance/MyBYBill') }
        },
        {
          path: 'BYList',
          name: 'BYList', //设备保养记录
          components: { BYList: () => import('@/pages/equipment/maintenance/BYList') }
        },
        {
          path: 'MyEquipRepairBill',
          name: 'MyEquipRepairBill', //设备维修---我维修
          components: { MyEquipRepairBill: () => import('@/pages/equipment/repair/MyEquipRepairBill') }
        },
        {
          path: 'MyComprehensiveRepairBill',
          name: 'MyComprehensiveRepairBill', //综合事务维修---我维修
          components: { MyComprehensiveRepairBill: () => import('@/pages/equipment/repair/MyComprehensiveRepairBill') }
        },
        {
          path: 'MyComprehensiveRepair',
          name: 'MyComprehensiveRepair', //综合事务维修---我报修
          components: { MyComprehensiveRepair: () => import('@/pages/equipment/repair/MyComprehensiveRepair') }
        },
        {
          path: 'MyEquipRepair',
          name: 'MyEquipRepair', //设备维修---我报修
          components: { MyEquipRepair: () => import('@/pages/equipment/repair/MyEquipRepair') }
        },
        {
          path: 'PurchaseReceipt',
          name: 'PurchaseReceipt',
          components: { PurchaseReceipt: () => import('@/pages/PurchaseReceipt') }
        },
        {
          path: 'MixOilRecipe',
          name: 'MixOilRecipe',
          components: { MixOilRecipe: () => import('@/pages/MixOilRecipe') }
        },
        {
          path: 'WorkShopSection',
          name: 'WorkShopSection',
          components: { WorkShopSection: () => import('@/pages/WorkShopSection') }
        },
        {
          path: 'ProducePick',
          name: 'ProducePick',
          components: { ProducePick: () => import('@/pages/ProducePick') }
        },
        {
          path: 'ItemInOutBook',
          name: 'ItemInOutBook',
          components: { ItemInOutBook: () => import('@/pages/ItemInOutBook') }
        },
        {
          path: 'TechnologyParameter',
          name: 'TechnologyParameter',
          components: { TechnologyParameter: () => import('@/pages/TechnologyParameter') }
        },
        {
          path: 'TechnologyScheme',
          name: 'TechnologyScheme',
          components: { TechnologyScheme: () => import('@/pages/TechnologyScheme') }
        },
        {
          path: 'Rapeseed',
          name: 'Rapeseed',
          components: { Rapeseed: () => import('@/pages/oil/Rapeseed') }
        },
        {
          path: 'OilsManage',
          name: 'OilsManage',
          components: { OilsManage: () => import('@/pages/oil/OilsManage') }
        },
        {
          path: 'OilProductPackage',
          name: 'OilProductPackage',
          components: { OilProductPackage: () => import('@/pages/oil/OilProductPackage') }
        },
        {
          path: 'PurchaseSuggest',
          name: 'PurchaseSuggest',
          components: { PurchaseSuggest: () => import('@/pages/PurchaseSuggest') }
        },
        {
          path: 'DataPermissionCategory',
          name: 'DataPermissionCategory',
          components: { DataPermissionCategory: () => import('@/pages/datapermisson/DataPermissionCategory') }
        },
        {
          path: 'WarehouseQuery',
          name: 'WarehouseQuery',
          components: { WarehouseQuery: () => import('@/pages/Warehouse/WarehouseQuery') }
        },
        {
          //库存明细查看
          path: 'WarehouseDetailQuery',
          name: 'WarehouseDetailQuery',
          components: { WarehouseDetailQuery: () => import('@/pages/Warehouse/WarehouseDetailQuery') }
        },
        {
          path: 'RoleDataPermission',
          name: 'RoleDataPermission',
          components: { RoleDataPermission: () => import('@/pages/datapermisson/RoleDataPermission') }
        },
        {
          path: 'ItemClass',
          name: 'ItemClass',
          components: { ItemClass: () => import('@/pages/ItemClass') }
        },
        {
          path: 'OtherPick',
          name: 'OtherPick',
          components: { OtherPick: () => import('@/pages/OtherPick') }
        },
        {
          path: 'OrganizationMgr',
          name: 'OrganizationMgr',
          components: { OrganizationMgr: () => import('@/pages/organization/OrganizationMgr') }
        },
        {
          path: 'AnnualMain',
          name: 'AnnualMain',
          components: { AnnualMain: () => import('@/pages/productionplan/annual/AnnualMain') }
        },
        {
          path: 'Apply',
          name: 'Apply',
          components: { Apply: () => import('@/pages/Apply') }
        },
        {
          path: 'OtherReceiving',
          name: 'OtherReceiving',
          components: { OtherReceiving: () => import('@/pages/OtherReceiving') }
        },
        {
          path: 'Unit',
          name: 'Unit',
          components: { Unit: () => import('@/pages/Unit') }
        },
        {
          // 入库
          path: 'Stockin',
          name: 'Stockin',
          components: { Stockin: () => import('@/pages/Stockin') }
        },
        {
          // 出库
          path: 'Stockout',
          name: 'Stockout',
          components: { Stockout: () => import('@/pages/Stockout') }
        },
        {
          // 物料存放规则
          path: 'MaterialRule',
          name: 'MaterialRule',
          components: { MaterialRule: () => import('@/pages/MaterialRule') }
        },
        {
          // 物料存放规则
          path: 'ProductReturn',
          name: 'ProductReturn',
          components: { ProductReturn: () => import('@/pages/ProductReturn') }
        },
        {
          path: 'TakeGoods',
          name: 'TakeGoods',
          components: { TakeGoods: () => import('@/pages/TakeGoods') }
        },
        {
          path: 'MonthlyMain',
          name: 'MonthlyMain',
          components: { MonthlyMain: () => import('@/pages/productionplan/monthly/MonthlyMain') }
        },
        {
          path: 'WeeklyMain',
          name: 'WeeklyMain',
          components: { WeeklyMain: () => import('@/pages/productionplan/weekly/WeeklyMain') },
          // meta: { keepAlive: false }
          // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
          meta: { isBack: false }
        },
        {
          path: 'WeeklyPlan',
          name: 'WeeklyPlan',
          components: { WeeklyPlan: () => import('@/pages/productionplan/weekly/WeeklyPlan') },
          // meta: { keepAlive: false }
          // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
          meta: { isBack: false }
        },
        {
          path: 'TaskMain',
          name: 'TaskMain',
          components: { TaskMain: () => import('@/pages/productiontask/TaskMain') }
        },
        {
          path: 'TaskDispatch',
          name: 'TaskDispatch',
          components: { TaskDispatch: () => import('@/pages/productiontask/TaskDispatch') }
        },
        {
          path: 'PrintTemplate',
          name: 'PrintTemplate',
          components: { PrintTemplate: () => import('@/pages/print/PrintTemplate') }
        },
        {
          path: 'UnloadLocation',
          name: 'UnloadLocation',
          components: { UnloadLocation: () => import('@/pages/BasicData/UnloadLocation') }
        },
        {
          path: 'TankInfo',
          name: 'TankInfo',
          components: { TankInfo: () => import('@/pages/tank/TankInfo') }
        },
        {
          path: 'TankFarmRuler',
          name: 'TankFarmRuler',
          components: { TankFarmRuler: () => import('@/pages/tank/TankFarmRuler') }
        },
        {
          path: 'TankDailyReport',
          name: 'TankDailyReport',
          components: { TankDailyReport: () => import('@/pages/tank/TankDailyReport') }
        },
        {
          path: 'TankInspection',
          name: 'TankInspection',
          components: { TankInspection: () => import('@/pages/tank/TankInspection') }
        },
        {
          //  托盘管理
          path: 'PalletInfo',
          name: 'PalletInfo',
          // component: resolve => require(['@/pages/PalletManage'], resolve)
          components: { PalletInfo: () => import('@/pages/Pallet/PalletInfoManage') }
        },
        {
          //  库区类型
          path: 'StorageSort',
          name: 'StorageSort',
          // component: resolve => require(['@/pages/PalletManage'], resolve)
          components: { StorageSort: () => import('@/pages/Storage/StorageSortManage') }
        },
        {
          path: 'BusinessConfig',
          name: 'BusinessConfig',
          components: { BusinessConfig: () => import('@/pages/BusinessConfig') }
        },
        {
          //收发油
          path: 'ReceiveOutOil',
          name: 'ReceiveOutOil',
          components: { ReceiveOutOil: () => import('@/pages/ReceiveOutOil') }
        },
        {
          //采购收货管理
          path: 'PurchaseReceiptManage',
          name: 'PurchaseReceiptManage',
          components: { PurchaseReceiptManage: () => import('@/pages/PurchaseReceiptManage') }
        },
        {
          //成品油规格管理
          path: 'OilSpecManage',
          name: 'OilSpecManage',
          components: { OilSpecManage: () => import('@/pages/OilSpecManage') }
        },
        {
          //初始化规则
          path: 'SystemRestore',
          name: 'SystemRestore',
          components: { SystemRestore: () => import('@/pages/SYS/SystemRestore') }
        },
        {
          // 仓库
          path: 'WarehouseInfo',
          name: 'WarehouseInfo',
          components: { WarehouseInfo: () => import('@/pages/Storage/WarehouseInfoManage') }
        },
        {
          // 称重录入
          path: 'WeighInput',
          name: 'WeighInput',
          components: { WeighInput: () => import('@/pages/weighRecords/WeighInput') }
        },
        {
          // 菜籽收购(临时)
          path: 'RapeseedBuyTemp',
          name: 'RapeseedBuyTemp',
          components: { RapeseedBuyTemp: () => import('@/pages/rapeseedBuyTemps/RapeseedBuyTemp') }
        },
        {
          // 项目
          path: 'Project',
          name: 'Project',
          components: { Project: () => import('@/pages/BasicData/Project') }
        },
        {
          // 项目分类
          path: 'ProjectClass',
          name: 'ProjectClass',
          components: { ProjectClass: () => import('@/pages/BasicData/ProjectClass') }
        },
        {
          // 项目组织
          path: 'ProjectOrganization',
          name: 'ProjectOrganization',
          components: { ProjectOrganization: () => import('@/pages/BasicData/ProjectOrganization') }
        },
        {
          // 存货分类
          path: 'InventoryClass',
          name: 'InventoryClass',
          components: { InventoryClass: () => import('@/pages/BasicData/InventoryClass') }
        },
        {
          // 部门
          path: 'Department',
          name: 'Department',
          components: { Department: () => import('@/pages/BasicData/Department') }
        },
        {
          // 员工资料
          path: 'Employee',
          name: 'Employee',
          components: { Employee: () => import('@/pages/BasicData/Employee') }
        },
        {
          // 组织架构
          path: 'OrganizationStructure',
          name: 'OrganizationStructure',
          components: { OrganizationStructure: () => import('@/pages/BasicData/OrganizationStructure') }
        },
        {
          // 往来单位分类
          path: 'PartnerClass',
          name: 'PartnerClass',
          components: { PartnerClass: () => import('@/pages/BasicData/PartnerClass') }
        },
        {
          // 往来单位组织
          path: 'PartnerClassOrganization',
          name: 'PartnerClassOrganization',
          components: { PartnerClassOrganization: () => import('@/pages/BasicData/PartnerClassOrganization') }
        },
        {
          // 地区资料
          path: 'District',
          name: 'District',
          components: { District: () => import('@/pages/BasicData/District') }
        },
        {
          // 往来单位
          path: 'Partner',
          name: 'Partner',
          components: { Partner: () => import('@/pages/BasicData/Partner') }
        },
        {
          // 品牌
          path: 'Product',
          name: 'Product',
          components: { Product: () => import('@/pages/BasicData/Product') }
        },
        {
          // 计量单位
          path: 'UnitInfo',
          name: 'UnitInfo',
          components: { UnitInfo: () => import('@/pages/BasicData/UnitInfo') }
        },
        {
          // 存货信息
          path: 'InventoryInfo',
          name: 'InventoryInfo',
          components: { InventoryInfo: () => import('@/pages/BasicData/InventoryInfo') }
        },
        {
          // 币种
          path: 'Currency',
          name: 'Currency',
          components: { Currency: () => import('@/pages/BasicData/Currency') }
        },
        {
          // 出入库类别
          path: 'RDStyle',
          name: 'RDStyle',
          components: { RDStyle: () => import('@/pages/BasicData/RDStyle') }
        },
        {
          // 业务分类
          path: 'BusiType',
          name: 'BusiType',
          components: { BusiType: () => import('@/pages/BasicData/BusiType') }
        },
        {
          //单据分类
          path: 'BillType',
          name: 'BillType',
          components: { BillType: () => import('@/pages/BasicData/BillType') }
        },
        {
          // 调配订单
          path: 'MixOilOrder',
          name: 'MixOilOrder',
          components: { MixOilOrder: () => import('@/pages/MixOil/MixOilOrder') }
        },
        {
          // 调配订单调配过程
          path: 'MixOilOrderDetail',
          name: 'MixOilOrderDetail',
          components: { MixOilOrderDetail: () => import('@/pages/MixOil/MixOilOrderDetail') }
        },
        {
          // 调配订单明细浏览
          path: 'MixOilOrderDetailView',
          name: 'MixOilOrderDetailView',
          components: { MixOilOrderDetailView: () => import('@/pages/MixOil/MixOilOrderDetailView') }
        },
        {
          // 行驶证
          path: 'VehiceInfo',
          name: 'VehiceInfo',
          components: { VehiceInfo: () => import('@/pages/BasicData/VehiceInfo') }
        },
        {
          // 司机信息
          path: 'DriverInfo',
          name: 'DriverInfo',
          components: { DriverInfo: () => import('@/pages/BasicData/DriverInfo') }
        },
        {
          // 签名
          path: 'Autograph',
          name: 'Autograph',
          components: { Autograph: () => import('@/pages/BasicData/Autograph') }
        },
        {
          // 叫号入厂
          path: 'CallFactory',
          name: 'CallFactory',
          components: { CallFactory: () => import('@/pages/PreInStore/CallFactory') }
        },
        {
          // 菜籽入库
          path: 'PreInStoreExtend',
          name: 'PreInStoreExtend',
          components: { PreInStoreExtend: () => import('@/pages/PreInStore/PreInStoreExtend') }
        },
        {
          // 出厂还卡
          path: 'FactoryCardReturn',
          name: 'FactoryCardReturn',
          components: { FactoryCardReturn: () => import('@/pages/PreInStore/CardReturnAudit') }
        },
        {
          // 审核入库
          path: 'AuditWarehouse',
          name: 'AuditWarehouse',
          components: { AuditWarehouse: () => import('@/pages/PreInStore/CardReturnAudit') }
        },
        {
          // 质检模板
          path: 'QTTemplate',
          name: 'QTTemplate',
          components: { QTTemplate: () => import('@/pages/BasicData/QTTemplate') }
        },
        {
          // 产成品入库
          path: 'ProductReceiveIn',
          name: 'ProductReceiveIn',
          components: { ProductReceiveIn: () => import('@/pages/StoreBill/ProductReceive') }
        },
        {
          // 产成品出库
          path: 'ProductReceiveOut',
          name: 'ProductReceiveOut',
          components: { ProductReceiveOut: () => import('@/pages/StoreBill/ProductReceive') }
        },
        {
          // 产成品出入库-添加修改
          path: 'ProductReceiveAddUpdateIn',
          name: 'ProductReceiveAddUpdateIn',
          components: { ProductReceiveAddUpdateIn: () => import('@/pages/StoreBill/ProductReceiveAddUpdate') }
        },
        {
          // 产成品出入库-添加修改
          path: 'ProductReceiveAddUpdateOut',
          name: 'ProductReceiveAddUpdateOut',
          components: { ProductReceiveAddUpdateOut: () => import('@/pages/StoreBill/ProductReceiveAddUpdate') }
        },
        {
          //进厂质检
          path: 'InQualityTest',
          name: 'InQualityTest',
          components: { InQualityTest: () => import('@/pages/PreInStore/InQualityTest') }
        },
        {
          //出入厂初检
          path: 'PreInStorePreQT1',
          name: 'PreInStorePreQT1',
          components: { PreInStorePreQT1: () => import('@/pages/PreInStore/PreInStoreQT') }
        },
        {
          //出入厂复检
          path: 'PreInStoreQT1',
          name: 'PreInStoreQT1',
          components: { PreInStoreQT1: () => import('@/pages/PreInStore/PreInStoreQT') }
        },
        {
          //出入厂初检
          path: 'PreInStorePreQT0',
          name: 'PreInStorePreQT0',
          components: { PreInStorePreQT0: () => import('@/pages/PreInStore/PreInStoreQT') }
        },
        {
          //出入厂复检
          path: 'PreInStoreQT0',
          name: 'PreInStoreQT0',
          components: { PreInStoreQT0: () => import('@/pages/PreInStore/PreInStoreQT') }
        },

        {
          //出入厂毛重
          path: 'PreInStoreGross',
          name: 'PreInStoreGross',
          components: { PreInStoreGross: () => import('@/pages/PreInStore/PreInStoreScale') }
        },
        {
          //出入厂毛重
          path: 'PreInStoreScaleV2',
          name: 'PreInStoreScaleV2',
          components: { PreInStoreScaleV2: () => import('@/pages/PreInStore/PreInStoreScaleV2') }
        },
        {
          //出入厂皮重
          path: 'PreInStoreUnladen',
          name: 'PreInStoreUnladen',
          components: { PreInStoreUnladen: () => import('@/pages/PreInStore/PreInStoreScale') }
        },
        {
          //菜籽入库流水
          path: 'RapeseedWarehouseFlow',
          name: 'RapeseedWarehouseFlow',
          components: { RapeseedWarehouseFlow: () => import('@/pages/PreInStore/RapeseedReport') }
        },
        {
          //菜籽过磅台账
          path: 'RapeseedScaleLedger',
          name: 'RapeseedScaleLedger',
          components: { RapeseedScaleLedger: () => import('@/pages/PreInStore/RapeseedReport') }
        },
        {
          //出入厂装卸
          path: 'PreInStoreLoad',
          name: 'PreInStoreLoad',
          components: { PreInStoreLoad: () => import('@/pages/PreInStore/PreInStoreLoad') }
        },
        {
          //系统枚举
          path: 'SysEnum',
          name: 'SysEnum',
          components: { SysEnum: () => import('@/pages/BasicData/SysEnum') }
        },
        {
          //入厂登记
          path: 'FactoryEntryRegister',
          name: 'FactoryEntryRegister',
          components: { FactoryEntryRegister: () => import('@/pages/PreInStore/FactoryEntryRegister') }
        },
        {
          //预约录入
          path: 'ReservationEntry',
          name: 'ReservationEntry',
          components: { ReservationEntry: () => import('@/pages/PreInStore/ReservationEntry') }
        },
        {
          //货位
          path: 'InvLocation',
          name: 'InvLocation',
          components: { InvLocation: () => import('@/pages/BasicData/InvLocation') }
        },
        {
          //采购入库单
          path: 'PurchaseWarehousing',
          name: 'PurchaseWarehousing',
          components: { PurchaseWarehousing: () => import('@/pages/PrevRDFactory/PrevRDFactoryBill') }
        },
        {
          //采购退货单
          path: 'PurchaseReturnGoods',
          name: 'PurchaseReturnGoods',
          components: { PurchaseReturnGoods: () => import('@/pages/PrevRDFactory/PrevRDFactoryBill') }
        },
        {
          //销售出库单
          path: 'SaleIssue',
          name: 'SaleIssue',
          components: { SaleIssue: () => import('@/pages/PrevRDFactory/PrevRDFactoryBill') }
        },
        {
          //销售退货单
          path: 'SaleReturnGoods',
          name: 'SaleReturnGoods',
          components: { SaleReturnGoods: () => import('@/pages/PrevRDFactory/PrevRDFactoryBill') }
        },
        {
          //材料出库单
          path: 'MaterialDispatchBillIn',
          name: 'MaterialDispatchBillIn',
          components: { MaterialDispatchBillIn: () => import('@/pages/StoreBill/MaterialDispatchBill') }
        },
        {
          //材料出库退货单
          path: 'MaterialDispatchBillOut',
          name: 'MaterialDispatchBillOut',
          components: { MaterialDispatchBillOut: () => import('@/pages/StoreBill/MaterialDispatchBill') }
        },
        {
          //材料出库单-添加修改
          path: 'MaterialDispatchBillAddUpdateIn',
          name: 'MaterialDispatchBillAddUpdateIn',
          components: { MaterialDispatchBillAddUpdateIn: () => import('@/pages/StoreBill/MaterialDispatchBillAddUpdate') }
        },
        {
          //材料出库单-添加修改
          path: 'MaterialDispatchBillAddUpdateOut',
          name: 'MaterialDispatchBillAddUpdateOut',
          components: { MaterialDispatchBillAddUpdateOut: () => import('@/pages/StoreBill/MaterialDispatchBillAddUpdate') }
        },
        {
          //粕库报表
          path: 'MealWarehouse',
          name: 'MealWarehouse',
          components: { MealWarehouse: () => import('@/pages/Report/MealWarehouse') }
        },
        {
          //副产品入库 2026-08-08 由吴伟修改 功能04
          path: 'ByproductInbound',
          name: 'ByproductInbound',
          components: { ByproductInbound: () => import('@/pages/Report/ByproductInbound') }
        },
        {
          //包装油BOM清单
          path: 'PackagingOilBom',
          name: 'PackagingOilBom',
          components: { PackagingOilBom: () => import('@/pages/BasicData/PackagingOilBom1') }
        },
        //2026-08-10 由吴伟修改 添加粕库报表路由
        {
          path: 'MealWarehouseDailyReport',
          name: 'MealWarehouseDailyReport',
          components: { MealWarehouseDailyReport: () => import('@/pages/Report/MealWarehouseDailyReport') }
        },
        //2026-08-10 由吴伟修改 添加存有报表路由
        {
          path: 'OilInventoryReport',
          name: 'OilInventoryReport',
          components: { OilInventoryReport: () => import('@/pages/Report/OilInventoryReport') }
        },
        //用电量报表
        {
          path: 'PowerReport',
          name: 'PowerReport',
          components: { PowerReport: () => import('@/pages/Energy/PowerReport') }
        },
        {
          //污水处理量报表
          path: 'SewageReport',
          name: 'SewageReport',
          components: { SewageReport: () => import('@/pages/Energy/SewageReport') }
        },
        {
          //用水量报表
          path: 'WaterReport',
          name: 'WaterReport',
          components: { WaterReport: () => import('@/pages/Energy/WaterReport') }
        },
        {
          //用蒸汽量报表
          path: 'SteamReport',
          name: 'SteamReport',
          components: { SteamReport: () => import('@/pages/Energy/SteamReport') }
        },
        {
          //用天然气量报表
          path: 'GasReport',
          name: 'GasReport',
          components: { SteamReport: () => import('@/pages/Energy/GasReport') }
        },
        {
          //生产报备
          path: 'TaskEvent',
          name: 'TaskEvent',
          components: { TaskEvent: () => import('@/pages/productiontask/TaskEvent') }
        },
        {
          //质检点位
          path: 'QTLocation',
          name: 'QTLocation',
          components: { QTLocation: () => import('@/pages/BasicData/QTLocation') }
        },
        {
          //存货质检设置
          path: 'InventoryQTSet',
          name: 'InventoryQTSet',
          components: { InventoryQTSet: () => import('@/pages/BasicData/InventoryQTSet') }
        },
        {
          //精炼生产订单明细
          path: 'RefineDetail',
          name: 'RefineDetail',
          components: { RefineDetail: () => import('@/pages/Refine/RefineDetail') }
        },
        {
          //浏览精炼生产订单明细
          path: 'RefineDetailView',
          name: 'RefineDetailView',
          components: { RefineDetailView: () => import('@/pages/Refine/RefineDetailView') }
        },
        {
          //烘干/预榨/浸出/包装  生产订单明细
          path: 'TaskDetail',
          name: 'TaskDetail',
          components: { TaskDetail: () => import('@/pages/productiontask/TaskDetail') }
        },
        {
          //烘干/预榨/浸出/包装  生产订单明细
          path: 'TaskDetailView',
          name: 'TaskDetailView',
          components: { TaskDetailView: () => import('@/pages/productiontask/TaskDetailView') }
        },
        {
          //过程质检-烘干
          path: 'DryQT',
          name: 'DryQT',
          //components: { DryQT: () => import('@/pages/QTs/Test') }
          components: { DryQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-清理
          path: 'ClearQT',
          name: 'ClearQT',
          components: { ClearQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-预产
          path: 'PreProductionQT',
          name: 'PreProductionQT',
          components: { PreProductionQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-预榨炒料
          path: 'PrePressedFriedMaterialsQT',
          name: 'PrePressedFriedMaterialsQT',
          components: { PrePressedFriedMaterialsQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-预榨产出
          path: 'PrePressedOutputQT',
          name: 'PrePressedOutputQT',
          components: { PrePressedOutputQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-预榨
          path: 'PrePress',
          name: 'PrePress',
          components: { PrePress: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-浸出
          path: 'LeachQT',
          name: 'LeachQT',
          components: { LeachQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-精炼
          path: 'RefineQT',
          name: 'RefineQT',
          //components: { RefineQT: () => import('@/pages/QTs/QTPrints/RefineProcessQualityPrintTemp.vue') }
          components: { RefineQT: () => import('@/pages/QTs/RefineQT') }
        },
        {
          //过程质检-调和
          path: 'ReconcileQT',
          name: 'ReconcileQT',
          components: { ReconcileQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //过程质检-包装
          path: 'PackingQT',
          name: 'PackingQT',
          components: { PackingQT: () => import('@/pages/QTs/ProcessQT') }
        },
        {
          //设备预警信息看板
          path: 'EquipmentAlarmKanban',
          name: 'EquipmentAlarmKanban',
          components: { EquipmentAlarmKanban: () => import('@/pages/kanban/EquipmentAlarmKanban') }
        },
        {
          //能源消耗情况看板
          path: 'EnergyStatusKanBan',
          name: 'EnergyStatusKanBan',
          components: { EnergyStatusKanBan: () => import('@/pages/kanban/EnergyStatusKanBan') }
        },
        //2026-08-07 由吴伟修改 添加成本效益看板路由
        {
          path: 'CostBenefitKanban',
          name: 'CostBenefitKanban',
          components: { CostBenefitKanban: () => import('@/pages/kanban/CostBenefitKanban') }
        },
        //2026-08-10 由吴伟修改 添加生产看板路由
        {
          path: 'ProductionKanBan',
          name: 'ProductionKanBan',
          components: { ProductionKanBan: () => import('@/pages/kanban/ProductionKanBan') }
        },
        {
          //其他质检-污水处理
          path: 'SewerageQT',
          name: 'SewerageQT',
          components: { SewerageQT: () => import('@/pages/QTs/OtherQT') }
        },
        {
          //其他质检-种子质检
          path: 'SeedQT',
          name: 'SeedQT',
          components: { SeedQT: () => import('@/pages/QTs/OtherQT') }
        },
        {
          //其他质检-油菜籽质检
          path: 'CanolaQT',
          name: 'CanolaQT',
          components: { CanolaQT: () => import('@/pages/QTs/OtherQT') }
        },
        {
          //仓库质检-筒仓
          path: 'SiloQT',
          name: 'SiloQT',
          components: { SiloQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //仓库质检-压榨毛油罐
          path: 'PressCrudeOilTankQT',
          name: 'PressCrudeOilTankQT',
          components: { PressCrudeOilTankQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //仓库质检-浸出毛油罐
          path: 'LeachingCrudeOilTankQT',
          name: 'LeachingCrudeOilTankQT',
          components: { LeachingCrudeOilTankQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //仓库质检-罐检测
          path: 'TankQT',
          name: 'TankQT',
          components: { TankQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //仓库质检-精炼成品油罐
          path: 'RefinedProductCrudeOilTankQT',
          name: 'RefinedProductCrudeOilTankQT',
          components: { RefinedProductCrudeOilTankQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //仓库质检-小包装仓库
          path: 'SmallPackagingWarehouseQT',
          name: 'SmallPackagingWarehouseQT',
          components: { SmallPackagingWarehouseQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //仓库质检-粕库
          path: 'MealStorehouseQT',
          name: 'MealStorehouseQT',
          components: { MealStorehouseQT: () => import('@/pages/QTs/WarehouseQT') }
        },
        {
          //包装车间生产看板
          path: 'PackagingWorkshopKanban',
          name: 'PackagingWorkshopKanban',
          components: { PackagingWorkshopKanban: () => import('@/pages/kanban/PackagingWorkshopKanban') }
        },
        {
          //精炼车间1号离心机
          path: 'JLWorkshopLXJ01Kanban',
          name: 'JLWorkshopLXJ01Kanban',
          components: { JLWorkshopLXJ01Kanban: () => import('@/pages/kanban/JLWorkshopLXJ01Kanban') }
        },
        {
          //精炼车间2号离心机
          path: 'JLWorkshopLXJ02Kanban',
          name: 'JLWorkshopLXJ02Kanban',
          components: { JLWorkshopLXJ02Kanban: () => import('@/pages/kanban/JLWorkshopLXJ01Kanban') }
        },
        {
          //自控变量配置-调配单
          path: 'TagConfigMixOilOrder',
          name: 'TagConfigMixOilOrder',
          components: { TagConfigMixOilOrder: () => import('@/pages/TagConfig/TagConfigMixOilOrder1') }
        },
        {
          //财务报表-收入报表
          path: 'Revenue',
          name: 'Revenue',
          components: { Revenue: () => import('@/pages/FinancialStatements/RevenueExpenditure') }
        },
        {
          //财务报表-支出报表
          path: 'Expenditure',
          name: 'Expenditure',
          components: { Expenditure: () => import('@/pages/FinancialStatements/RevenueExpenditure') }
        },
        {
          //财务报表-年度预算
          path: 'Budget',
          name: 'Budget',
          components: { Budget: () => import('@/pages/FinancialStatements/BudgetBalance') }
        },
        {
          //财务报表-预算结余
          path: 'Balance',
          name: 'Balance',
          components: { Balance: () => import('@/pages/FinancialStatements/BudgetBalance') }
        },
        {
          //财务报表-种植订单
          path: 'PlantingOrder',
          name: 'PlantingOrder',
          components: { PlantingOrder: () => import('@/pages/FinancialStatements/PlantingOrder') }
        },
        {
          //托盘管理 - 托盘注册
          path: 'PalletRegister',
          name: 'PalletRegister',
          components: { PalletRegister: () => import('@/pages/Pallet/PalletRegister') }
        },
        {
          //托盘管理 - 托盘归还
          path: 'PalletReturn',
          name: 'PalletReturn',
          components: { PalletReturn: () => import('@/pages/Pallet/PalletReturn') }
        },
        {
          //托盘管理 - 托盘报废
          path: 'PalletScrap',
          name: 'PalletScrap',
          components: { PalletScrap: () => import('@/pages/Pallet/PalletScrap') }
        },
        {
          //托盘管理 - 托盘领用
          path: 'PalletLend',
          name: 'PalletLend',
          components: { PalletLend: () => import('@/pages/Pallet/PalletLend') }
        },
        {
          //车辆出入厂记录
          path: 'InOutRecords',
          name: 'InOutRecords',
          components: { InOutRecords: () => import('@/pages/InOutRecords/InOutRecords') }
        },
        {
          //请购单
          path: 'PurchaseRequisition',
          name: 'PurchaseRequisition',
          components: { PurchaseRequisition: () => import('@/pages/PurchaseRequisition/PurchaseRequisitionBill') }
        },
        {
          //托盘入库单
          path: 'PalletRDBill1',
          name: 'PalletRDBill1',
          components: { PalletRDBill1: () => import('@/pages/Pallet/PalletRDBill') }
        },
        {
          //托盘出库单
          path: 'PalletRDBill0',
          name: 'PalletRDBill0',
          components: { PalletRDBill0: () => import('@/pages/Pallet/PalletRDBill') }
        },
        {
          path: 'PackagingWorkshopPower',
          name: 'PackagingWorkshopPower',
          components: { PackagingWorkshopPower: () => import('@/pages/HomeComponent/PackagingWorkshopPower') }
        },
        {
          path: 'DigitalTips2',
          name: 'DigitalTips2',
          components: { DigitalTips2: () => import('@/pages/kanban/DigitalTips2') }
        },
        {
          path: 'PackageOilReport',
          name: 'PackageOilReport',
          components: { PackageOilReport: () => import('@/pages/productiontask/PackageOilReport') }
        },
        {
          path: 'PackageOilTracing',
          name: 'PackageOilTracing',
          components: { PackageOilTracing: () => import('@/pages/productiontask/PackageOilTracing') }
        },
        //角色视图权限
        {
          path: 'RoleViewPermissions',
          name: 'RoleViewPermissions',
          components: { RoleViewPermissions: () => import('@/pages/ViewPermissions/RoleViewPermissions') }
        },
        //视图管理
        {
          path: 'ViewManage',
          name: 'ViewManage',
          components: { ViewManage: () => import('@/pages/ViewPermissions/ViewManage') }
        },
        {
          path: 'PreInStoreDetailReportMeal',
          name: 'PreInStoreDetailReportMeal',
          components: { PreInStoreDetailReportMeal: () => import('@/pages/PreInStore/MealReport') }
        },
        {
          path: 'MealReport',
          name: 'MealReport',
          components: { MealReport: () => import('@/pages/HomeComponent/MealReport') }
        },
        {
          path: 'PreInStoreManage',
          name: 'PreInStoreManage',
          components: { PreInStoreManage: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        {
          path: 'PreInStoreManage0',
          name: 'PreInStoreManage0',
          components: { PreInStoreManage0: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        {
          path: 'PreInStoreManage1',
          name: 'PreInStoreManage1',
          components: { PreInStoreManage1: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        {
          path: 'PreInStoreManage11',
          name: 'PreInStoreManage11',
          components: { PreInStoreManage11: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        {
          path: 'PreInStoreManage10',
          name: 'PreInStoreManage10',
          components: { PreInStoreManage10: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        {
          //20260618 2356 吴伟 新增散油入库路由，与散油出库共用PreInStoreManage组件，通过路由名区分散油出入库方向
          path: 'PreInStoreManage12',
          name: 'PreInStoreManage12',
          components: { PreInStoreManage12: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        {
          path: 'PreInStoreManage20',
          name: 'PreInStoreManage20',
          components: { PreInStoreManage20: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        //2026-08-10 由吴伟修改 非标菜籽收购一卡通
        {
          path: 'PreInStoreManage21',
          name: 'PreInStoreManage21',
          components: { PreInStoreManage21: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        //2026-08-10 由吴伟修改 玉米入场一卡通
        {
          path: 'PreInStoreManage22',
          name: 'PreInStoreManage22',
          components: { PreInStoreManage22: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        //2026-08-10 由吴伟修改 玉米出厂一卡通
        {
          path: 'PreInStoreManage23',
          name: 'PreInStoreManage23',
          components: { PreInStoreManage23: () => import('@/pages/PreInStore/PreInStoreManage') }
        },
        //系统日志
        {
          path: 'LogTabs',
          name: 'LogTabs',
          components: { LogTabs: () => import('@/pages/SYS/LogsTabs') }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js